import isValueEmpty from 'hb-react/shared/utils/isValueEmpty';

export const errorMessage = s__(
  'EmailCampaigns|You can enter up to %{maxEmailsInline} email addresses maximum',
);

export const validateMaxEmailsInline = (value, maxEmailsInline) => {
  let error;

  if (isValueEmpty(value)) {
    return error;
  }

  const emailsSplit = value
    .split(/[,;\n\t]+/)
    .map((email) => email.trim())
    .filter((email) => email.length > 0);

  if (emailsSplit.length > maxEmailsInline) {
    error = errorMessage.i__({
      maxEmailsInline,
    });
  }

  return error;
};
